module.exports = __webpack_public_path__ + "img/boolstrap.3df19ce9.png";